<template>
  <TabList
    :activeTab="activeTabIndex"
    :customActiveTabStyle="$style.activeTab"
    :customNavStyle="$style.tabNav"
    :customTabStyle="$style.tabLink"
    :tabs="tabs"
    @active-tab-change="handleActiveTabChange"
  />
</template>

<script>
import { ItemTypeConsts, ItemTypeRoutes } from 'client/util/Constants';
import DevicesHomeMainPanel from 'client/systems/DevicesHomeMainPanel';
import DevicesSettingsMainPanel from 'client/systems/DevicesSettingsMainPanel';
import MainPanelMixin from 'client/components/MainPanel/mixins/MainPanelMixin';
import RouterService from 'client/util/RouterService';
import SystemsMainPanel from 'client/components/MainPanel/SystemsMainPanel';
import TabList from 'client/components/TabList/TabList';

export default {
  name: 'DevicesTabsMainPanel',

  components: {
    TabList,
  },

  mixins: [MainPanelMixin],

  props: {
    initialTabIndex: {
      type: Number,
      default: 0,
    },

    setSelectedModelId: {
      default: () => {},
      type: Function,
    },
  },

  computed: {
    activeTabIndex() {
      return this.initialTabIndex ? this.initialTabIndex : 0;
    },

    settinsIconStyle() {
      return {
        'padding-right': '5px',
        top: '2px',
        position: 'relative',
      };
    },

    tabs() {
      return [
        {
          title: 'Overview',
          component: DevicesHomeMainPanel,
        },
        {
          title: 'Devices',
          component: SystemsMainPanel,
          componentProps: {
            gettingStartedItemType: ItemTypeConsts.device,
            isAsideOpen: false,
            itemType: ItemTypeConsts.device,
            selectedModelId: '',
            setSelectedModelId: this.setSelectedModelId,
          },
        },
        {
          title: 'Manage Devices',
          component: DevicesSettingsMainPanel,
          icon: 'settings',
          iconStyle: this.settinsIconStyle,
          to: '/devices/settings',
        },
      ];
    },
  },

  methods: {
    handleActiveTabChange(tabIndex) {
      let path = ItemTypeRoutes[ItemTypeConsts.device];

      switch (tabIndex) {
        case 0:
          path = `${path}/overview`;
          break;
        case 1:
          path = `${path}/list`;
          break;
        default:
          path = `${path}/settings`;
          break;
      }

      RouterService.redirect({
        path,
        viewport: this.viewport,
        vueRouter: this.$router,
      });
    },
  },
};
</script>

<style module>
.activeTab a {
  border-bottom: 2px solid var(--jcPrimary);
  color: var(--jcGrey600);
}

.tabLink {
  color: var(--jcGrey);
  font-size: 1.2rem;
  font-weight: bold;
  padding-bottom: 4px;
}

.tabNav {
  margin: 20px 0 10px 20px;
}

.tabNav li:last-child {
  margin-left: auto;
}

.tabNav li:last-child a {
  color: var(--jc-color-informational-base);
  font-size: 1rem;
}

</style>
